<template>
  <div>
    <!-- <h3>Accordion Example</h3> -->
    <div class="panel-group" id="accordion">
      <div
        class="panel panel-default"
        v-for="(item, index) in configEmailGroupList"
        :key="item + index"
      >
        <div
          class="panel-heading"
          :href="`#collapse${index}`"
          data-toggle="collapse"
          data-parent="#accordion"
          role="button"
          @click="onSelectTab(index)"
        >
          <h4 class="panel-title">
            <a>{{ item.name }}</a>
          </h4>
        </div>
        <div
          :id="`collapse${index}`"
          :class="
            index == 0
              ? `panel-collapse collapse in`
              : `panel-collapse collapse`
          "
        >
          <div class="panel-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">{{
                      $t("feedback.config.departmentTitle")
                    }}</label>
                    <v-select
                      class="clear"
                      :options="departmentList"
                      :reduce="data => data.id"
                      :getOptionLabel="option => $t(option.name)"
                      v-model="item.department"
                      :placeholder="$t('feedback.config.departmentTitle')"
                      @option:selected="onChangeDepartment"
                      disabled
                    >
                      <template #list-header>
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">
                                {{ $t("feedback.config.departmentName") }}
                              </th>
                              <th scope="col">{{ $t("feedback.config.departmentEmail") }}</th>
                            </tr>
                          </thead>
                        </table>
                      </template>
                      <template v-slot:option="option">
                        <div
                          style="display: flex; padding-top: 5px; padding-bottom: 5px; border-bottom: 1px solid #ccc"
                        >
                          <div style="width: 50%; word-break: break-all;">
                            {{ $t(option.name) }}
                          </div>
                          <div style="width: 50%">
                            {{ $t(option.email) }}
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">{{ $t("common.email") }}</label>
                    <input
                      type="email"
                      class="form-control"
                      :placeholder="$t('common.email')"
                      v-model="item.email"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <button
                    type="button"
                    class="btn btn-primary btn-green pull-right"
                    @click="onSaveEmailGroup(item)"
                  >
                    {{ $t("common.confirm") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import LTECoreAlert from "@/components/LTESnackBar.vue";

export default {
  components: {
    "lte-core-alert": LTECoreAlert
  },
  data: () => ({
    configEmailGroupList: [],
    tabSelectIndex: 0,
    departmentList: [],
    departmentData: {
      email: null
    }
  }),
  watch: {
    GET_CONFIG_EMAIL_GROUP_DATA: function() {
      this.configEmailGroupList = [];
      let data = this.GET_CONFIG_EMAIL_GROUP_DATA;
      data.forEach(v => {
        let item = {
          id: v.id,
          name: v.name,
          email: v.department_email,
          department: v.department
        };
        this.configEmailGroupList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_CONFIG_EMAIL_GROUP_DATA"
    ])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    getConfigEmailGroup: function() {
      this.GET_CONFIG_EMAIL_GROUP();
    },
    onSaveEmailGroup: function(item) {
      if (utils.isEmptyString(item.department)) {
        this.showError('feedback.config.departmentTitle');
      } else if (utils.isEmptyString(item.email)) {
        this.showError(item.name);
      } else {
        let data = {
          email_group: item.id,
          email: item.email,
          department: item.department
        };
        this.POST_CONFIG_EMAIL_GROUP(data)
          .then(
            function() {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              let mess = error.response.data.message;
              this.showError(mess);
            }.bind(this)
          );
      }
    },
    getDepartmentList: function() {
      this.GET_DEPARTMENT_LIST().then(
        function(res) {
          let data = res;
          this.departmentList = [];
          data.forEach(value => {
            let item = {
              id: value.id,
              name: value.name,
              email: value.email
            };
            this.departmentList.push(item);
          });
        }.bind(this)
      );
    },
    onChangeDepartment: function(data) {
      this.configEmailGroupList[this.tabSelectIndex].email = data.email
    },
    onSelectTab: function(index) {
      this.tabSelectIndex = index
    },
    onRefreshData: function() {
      this.getDepartmentList();
      this.getConfigEmailGroup();
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_CONFIG_EMAIL_GROUP",
      "POST_CONFIG_EMAIL_GROUP",
      "SUCCESS_TOAST",
      "GET_DEPARTMENT_LIST"
    ])
  },
  mounted() {
    this.getDepartmentList();
    this.getConfigEmailGroup();
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/Project/ConfigEmailGroup.vue